import { useState } from "react";
import { Lightbulb, ChevronDown, ChevronUp } from "lucide-react";

/** Tour guidato di sezione: "Cosa fare qui" con passi numerati; chiuso/aperto ricordato per chiave. */
export const GuidaSezione = ({ k, titolo = "Cosa fare qui", passi, nota }) => {
  const key = `beaichy_guida_${k}`;
  const [open, setOpen] = useState(() => localStorage.getItem(key) !== "chiusa");
  const toggle = () => { localStorage.setItem(key, open ? "chiusa" : "aperta"); setOpen(!open); };
  return (
    <div className="mt-3 rounded-lg border border-sky-100 bg-sky-50/60 text-xs text-slate-700" data-testid={`guida-${k}`}>
      <button type="button" onClick={toggle} className="w-full flex items-center gap-2 px-3 py-2 text-left font-medium text-[#003087]" data-testid={`guida-${k}-toggle`}><Lightbulb size={13} /> {titolo}<span className="ml-auto text-slate-400">{open ? <ChevronUp size={13} /> : <ChevronDown size={13} />}</span></button>
      {open && <ol className="px-3 pb-3 space-y-1 list-decimal list-inside" data-testid={`guida-${k}-passi`}>{passi.map((p, i) => <li key={i} className="leading-relaxed">{p}</li>)}{nota && <li className="list-none text-slate-500 pt-1">{nota}</li>}</ol>}
    </div>
  );
};
